<template lang="pug">
  include Payment.pug
</template>

<script type="text/javascript">
import api from "@/service/api"
import utils from "@/service/utils"
import { mapState } from "vuex";

export default {
  name: "Payment",
  props: ["family"],
  computed: mapState([
    "token",
    "username"
  ]),
  data() {
    return {
      item: null,
    }
  },
  async created() {
    const familyResponse = await api.treeFiltered(this.token, this.family)
    this.item = familyResponse.data.tree[0]
  },
  methods: {
    payment: async function() {
      const response = await api.createSubscription(this.token, this.family)
      const data = response.data
      const linkPayment = data.link_payment
      window.location.href = linkPayment
    }
  },
  filters: {
    price: (newValue) => {
      return utils.price(newValue)
    }
  }
}
</script>
